import { Model } from 'app/model/backendmodel';
import { MicrosoftAccessLinkedService } from './../../linkedservice/microsoft-access.linkedservice';
import { IModel } from 'app/model/base/annotation';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Metamodel } from 'app/model/base/model';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';
import { AdapterRegistry } from '../adapter-registry';
import { ValueAdapter } from '../value.adapter';
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MicrosoftAccessLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                connectionString: 'secret',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                credential: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class MicrosoftAccessLinkedServiceAdapter extends LinkedServiceAdapter<MicrosoftAccessLinkedService> {
    protected supportFirstClassParameterExperience = true;
    protected modelConstructor(): new () => MicrosoftAccessLinkedService {
        return MicrosoftAccessLinkedService;
    }

    protected model(): IModel {
        return MicrosoftAccessLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: MicrosoftAccessLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.OdbcLinkedService;
        properties.type = Metamodel.modelFor(MicrosoftAccessLinkedService).name;

        const connectionString: string | Model.SecretBase = parameterizablePasswordOrAKVtoSecretBase(linkedService, MicrosoftAccessLinkedService.CONNECTION_STRING, this.context);
        const userName: string = linkedService.authenticationType === 'Basic' ? this.valueToResource(linkedService, MicrosoftAccessLinkedService.USER_NAME) : undefined;
        const password: string | Model.SecretBase = linkedService.authenticationType === 'Basic' ? parameterizablePasswordOrAKVtoSecretBase(linkedService, MicrosoftAccessLinkedService.PASSOWRD, this.context) : undefined;
        const credential: string | Model.SecretBase = linkedService.credential ? parameterizablePasswordOrAKVtoSecretBase(linkedService, MicrosoftAccessLinkedService.CREDENTIAL, this.context) : undefined;

        properties.typeProperties = {
            connectionString,
            authenticationType: linkedService.authenticationType,
            userName,
            password,
            credential
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(modelLinkedServiceResource: Model.LinkedServiceResource, linkedService: MicrosoftAccessLinkedService): Promise<MicrosoftAccessLinkedService> {
        const properties = modelLinkedServiceResource.properties as Model.OdbcLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.OdbcLinkedServiceTypeProperties = properties.typeProperties;
        parameterizableSecretBaseToModel(linkedService, MicrosoftAccessLinkedService.CONNECTION_STRING, typeProperties.connectionString, this.context, true);
        ValueAdapter.toModel(linkedService, MicrosoftAccessLinkedService.USER_NAME, typeProperties.userName);
        parameterizableSecretBaseToModel(linkedService, MicrosoftAccessLinkedService.PASSOWRD, typeProperties.password, this.context, linkedService.authenticationType === 'Basic');
        parameterizableSecretBaseToModel(linkedService, MicrosoftAccessLinkedService.CREDENTIAL, typeProperties.credential, this.context, true);

        linkedService.authenticationType = typeProperties.authenticationType;
        return linkedService;
    }
}
